import React from "react";
import classes from "./Sectors.module.scss";
import { Link } from "react-router";
import {useTranslation} from "react-i18next";
import rightArrowIcon from "../../media/icons/arrowRightBlack.svg";


const SectorCard = ({ image, title, text, smallCards, link = undefined }) => {
    const { t } = useTranslation();

    return  (
    <Link to={link} className={classes['sector-card']}>
        <img
          src={image}
          alt={title}
          className={classes["sector-card__image"]}
        />
          <div className={classes["sector-card__text"]}>
            <h3 className={classes["sector-card__text--title"]}>{title}</h3>
            <p className={classes["sector-card__text--body"]}>{text}</p>
          </div>
            <span className={classes["project-link"]}>
                {t("buttons.learnMore")} <img src={rightArrowIcon} alt="Arrow icon" />
            </span>
    </Link>
  );
};

export default SectorCard;
